export default "__VITE_ASSET__CA9ftz46__"